// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsSection} from '@app/features/app/components/dialogs/shared/SettingsSection';
import {ActiveNowTabContent} from '@app/features/user/components/modals/tabs/appearance_tab/ActiveNowTab';
import {ChannelListTabContent} from '@app/features/user/components/modals/tabs/appearance_tab/ChannelListTab';
import {FavoritesTabContent} from '@app/features/user/components/modals/tabs/appearance_tab/FavoritesTab';
import {HdrTabContent, shouldShowHdrSettings} from '@app/features/user/components/modals/tabs/appearance_tab/HdrTab';
import styles from '@app/features/user/components/modals/tabs/appearance_tab/Inline.module.css';
import {InterfaceTabContent} from '@app/features/user/components/modals/tabs/appearance_tab/InterfaceTab';
import {MessagesTabContent} from '@app/features/user/components/modals/tabs/appearance_tab/MessagesTab';
import {
	AppZoomLevelTabContent,
	FontSizeTabContent,
} from '@app/features/user/components/modals/tabs/appearance_tab/ScalingTab';
import {ThemeTabContent} from '@app/features/user/components/modals/tabs/appearance_tab/theme/ThemeTabContent';
import {shouldShowAppZoomLevel} from '@app/features/user/components/settings_utils/AppZoomLevelUtils';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
export const AppearanceInlineContent: React.FC = observer(() => {
	const {t} = useLingui();
	const showHdrSettings = shouldShowHdrSettings();
	const showZoomLevel = shouldShowAppZoomLevel();
	return (
		<div className={styles.container}>
			<SettingsSection id="theme" title={t`Theme`}>
				<ThemeTabContent />
			</SettingsSection>
			{showHdrSettings ? (
				<SettingsSection id="hdr" title={t`High Dynamic Range`}>
					<HdrTabContent />
				</SettingsSection>
			) : null}
			<SettingsSection id="chat-font-scaling" title={t`Chat Font Scaling`}>
				<FontSizeTabContent />
			</SettingsSection>
			{showZoomLevel ? (
				<SettingsSection id="app-zoom-level" title={t`App Zoom Level`}>
					<AppZoomLevelTabContent />
				</SettingsSection>
			) : null}
			<SettingsSection id="messages" title={t`Messages`}>
				<MessagesTabContent />
			</SettingsSection>
			<SettingsSection id="interface" title={t`Interface`}>
				<InterfaceTabContent />
			</SettingsSection>
			<SettingsSection id="channel-list" title={t`Channel List`}>
				<ChannelListTabContent />
			</SettingsSection>
			<SettingsSection id="active-now" title={t`Active Now`}>
				<ActiveNowTabContent />
			</SettingsSection>
			<SettingsSection id="favorites" title={t`Favorites`}>
				<FavoritesTabContent />
			</SettingsSection>
		</div>
	);
});
